import {createReducer, createActions} from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
  carErrorsRequest: ['id'],
  carErrorsSuccess: ['id', 'data'],
  carErrorsCleanRequest: ['id'],
  carErrorsArchiveRequest: ['id', 'props'],
  carErrorsArchiveSuccess: ['data'],
  carErrorsFailure: ['error'],
});

export const CarErrorsTypes = Types;
export default Creators;

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  current: {},
  id: null, //Нужно для обновления архивного списка
  data: null,
  totalPages: 0,
  error: null,
  fetching: false,
});

/* ------------- Reducers ------------- */

// we're attempting to ...
export const request = (state, {id}) => {
  if (state.id !== id) {
    return state.merge({id, error: null, data: null, fetching: true});
  }
  return state.merge({error: null, fetching: true});
};

// we've successfully ...
export const success = (state, {id, data}) =>
  state.merge({fetching: false, error: null, current: {...state.current, [id]: data}});

export const archiveSuccess = (state, {data}) => 
  state.merge({
    fetching: false,
    error: null,
    data: data ? data.page && data.page > 1 ? [...state.data, ...data.data] : data.data : null,
    totalPages: data && data.totalPages ? data.totalPages : 0,
  });

// we've had a problem ...
export const failure = (state, {error}) =>
  state.merge({fetching: false, error});


/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CAR_ERRORS_REQUEST]: request,
  [Types.CAR_ERRORS_SUCCESS]: success,
  [Types.CAR_ERRORS_CLEAN_REQUEST]: request,
  [Types.CAR_ERRORS_ARCHIVE_REQUEST]: request,
  [Types.CAR_ERRORS_ARCHIVE_SUCCESS]: archiveSuccess,
  [Types.CAR_ERRORS_FAILURE]: failure,
});
